

// object to store loaded CSS chunks
var installedCssChunks = {
	826: 0
}
__webpack_require__.f.compat = function(chunkId, promises) {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"34":1,"120":1,"340":1,"408":1,"845":1,"912":1,"942":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "" + {"18":"6550248fe51777cbb7bf","34":"171629c8730d946fb273","37":"063479c73f78a6231065","88":"3ce16daa528cee77235f","119":"dc02c3780682223f3602","120":"ab6e11c3467f945d7bb9","159":"940fb93c735399b4f4d6","340":"d5801685f49408dabf66","346":"66cdccfe535b7278aae8","362":"1c95cef67f959d6e0643","373":"2023cf6236ca08dd09d4","378":"64bc6f82a7986d216bf1","406":"f7afde7411a65c267042","408":"0f362b227b8416d92001","413":"609be20195139496b78b","422":"fdd8308ad4a0ba6c5fa2","459":"b4aa3c6fffd15c5f78b6","464":"f0897ed69750ef98319e","495":"a5936ce8c2b81cbf0f92","557":"af14acf51e3b8ce53628","578":"0084cb0191c80429755c","586":"4c27ee9b1f353eb1da46","603":"5c3abe5ce7fabbb8566e","737":"cc5e15b04f997d50c4e0","770":"432c02e696bb60ff1620","781":"9126f9e2f12d3615e0d6","786":"11a100029eb1a9407172","827":"8420f15044b8a8931109","831":"b35d0531029e3f658ee1","845":"f51c6f86f63908f94d53","848":"4187974ab68c4afaf8e0","850":"8f30eb2bc0716257bec0","863":"6beda0937c4f219a9be5","877":"6020799f38013e10acfe","894":"29749ba32c78c474799f","897":"f7a3b0f1163d68ee2329","912":"f23c2c8cfc4324964b95","942":"8221ef30174dc36356c1","970":"97846a5a1df0d4dc8e95"}[chunkId] + "/style.css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};